require('./brokerMarketsAgendaView.scss');

const React = require('react');
const { connect } = require('react-redux');
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { ContentBox } = require('commonsComponents/contentBox');
const { OKCover } = require('commonsComponents/OKCover');
const iframeResizer = require('iframe-resizer');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const moment = require('moment');
const { DATE_FORMAT_API } = require('constants/index');

class BrokerMarketsAgendaView extends React.Component {

    componentDidMount() {
        iframeResizer.iframeResizer();
    }

    render() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-brokerMarketsAgenda'),
                url: ''
            }
        ];

        const today = moment().format(DATE_FORMAT_API);
        const iframeUrl = `https://openbank-analisis.webfg.com/agenda/es/${today}`;

        return (
            <div className="broker-markets-agenda-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={getFinalTitle('broker-marketsAgendaTitle')}
                    />
                </OKCover>
                <div className="broker-markets-agenda-view__body">
                    <ContentBox
                        customClassName="broker-markets-agenda-view__agenda-box"
                    >
                        <iframe className="broker-markets-agenda-view__iframe" src={iframeUrl} />
                    </ContentBox>
                </div>
            </div>
        );
    }
}


BrokerMarketsAgendaView.propTypes = {

};

module.exports.constructor = BrokerMarketsAgendaView;
module.exports.BrokerMarketsAgendaView = connect()(BrokerMarketsAgendaView);
